import type { ReactNode } from 'react';
import { Button } from '@/components';
import styles from './operatorPanel.module.css';

export function Th({ children }: { children?: ReactNode }) {
  return <th className={styles.th}>{children}</th>;
}

export type PillTone = 'success' | 'warning' | 'neutral' | 'danger';

const TONE_CLASS: Record<PillTone, string> = {
  success: styles.pillSuccess,
  warning: styles.pillWarning,
  neutral: styles.pillNeutral,
  danger:  styles.pillDanger,
};

export function Pill({ tone, children }: { tone: PillTone; children: ReactNode }) {
  return <span className={`${styles.pill} ${TONE_CLASS[tone]}`}>{children}</span>;
}

export function OperatorPagination({
  page, totalPages, onPageChange,
  prevLabel = 'Vorige', nextLabel = 'Volgende', pageLabel = (p: number, t: number) => `Pagina ${p} / ${t}`,
}: {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  prevLabel?: string;
  nextLabel?: string;
  pageLabel?: (page: number, totalPages: number) => string;
}) {
  if (totalPages <= 1) return null;
  return (
    <div style={{ display: 'flex', gap: 'var(--space-1)', marginTop: 'var(--space-2)', alignItems: 'center' }}>
      <Button variant="ghost" onClick={() => onPageChange(Math.max(1, page - 1))} disabled={page === 1}>
        {prevLabel}
      </Button>
      <span style={{ fontSize: 'var(--text-sm)' }}>{pageLabel(page, totalPages)}</span>
      <Button variant="ghost" onClick={() => onPageChange(Math.min(totalPages, page + 1))} disabled={page === totalPages}>
        {nextLabel}
      </Button>
    </div>
  );
}

// Shared by the doctor and patient operator tables — an account is either
// active or manually suspended by an operator (with an optional reason).
export function AccountStatusPill({ suspended, reason }: { suspended: boolean; reason?: string | null }) {
  return (
    <>
      <Pill tone={suspended ? 'warning' : 'success'}>{suspended ? 'Gedeactiveerd' : 'Actief'}</Pill>
      {suspended && reason && (
        <div className={styles.mutedText} style={{ marginTop: 4 }}>{reason}</div>
      )}
    </>
  );
}
